import _clonedeep from 'lodash.clonedeep'

export default {
  props: {
    /**
     * @description 表格数据
     */
    pagination: {
      type: Object,
      default: null
    },
    /**
     * @description 是否开启当总条数小于一页时不显示分页
     */
    ltOnePage: {
      type: Boolean,
      default: false
    },
    /**
     * @description 是否开启客户端分页，默认为服务端分页
     */
    clientPagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 表格内部的分页
      apexTablePagination: null
    }
  },
  computed: {
    paginationShow() {
      if (this.ltOnePage) {
        return this.apexTablePagination.total > this.apexTablePagination.pageSize
      } else {
        return true
      }
    }
  },
  watch: {
    pagination: {
      handler() {
        this.handlePaginationChange()
      },
      deep: true
    }
  },
  mounted() {
    this.handlePaginationChange()
  },
  methods: {
    // 同步外部表格分页数据到apexTableData内部
    handlePaginationChange() {
      if (this.apexTablePagination !== this.pagination) {
        this.apexTablePagination = _clonedeep(this.pagination)
      }
      if (this.clientPagination) {
        this.initClientPagination()
      }
    },
    // 初始化客户端分页
    initClientPagination() {
      this.apexTableData = this.data.slice(0, this.apexTablePagination.pageSize)
      this.apexTablePagination.total = this.data.length
      this.apexTablePagination.currentPage = 1
    },
    // 客户端分页数据处理
    clientPaginationChangeData(currentPage) {
      if (this.clientPagination) {
        this.apexTablePagination.currentPage = currentPage
        this.apexTableData = this.data.slice(
          (this.apexTablePagination.currentPage - 1) * this.apexTablePagination.pageSize,
          this.apexTablePagination.currentPage * this.apexTablePagination.pageSize
        )
      }
    },
    /**
     * @description 每页条数改变
     */
    handlePaginationSizeChange(pageSize) {
      if (this.clientPagination) {
        this.apexTablePagination.pageSize = pageSize
        this.clientPaginationChangeData(this.apexTablePagination.currentPage)
      }
      this.$emit('pagination-size-change', pageSize)
    },
    /**
     * @description 当前页码改变
     */
    handlePaginationCurrentChange(currentPage) {
      this.clientPaginationChangeData(currentPage)
      this.$emit('pagination-current-change', currentPage)
    },
    /**
     * @description 上一页
     */
    handlePaginationPrevClick(currentPage) {
      this.$emit('pagination-prev-click', currentPage)
    },
    /**
     * @description 下一页
     */
    handlePaginationNextClick(currentPage) {
      this.$emit('pagination-next-click', currentPage)
    }
  }
}
